import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
var styles = {
  large: {
    width: '32px'
  },
  medium: {
    width: '16px'
  },
  small: {
    width: '8px'
  }
};

var HSpacer =
/*#__PURE__*/
function (_Component) {
  _inherits(HSpacer, _Component);

  function HSpacer() {
    _classCallCheck(this, HSpacer);

    return _possibleConstructorReturn(this, _getPrototypeOf(HSpacer).apply(this, arguments));
  }

  _createClass(HSpacer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          small = _this$props.small,
          medium = _this$props.medium;
      var allClasses = [];

      if (small) {
        allClasses.push(classes.small);
      } else if (medium) {
        allClasses.push(classes.medium);
      } else {
        allClasses.push(classes.large);
      }

      return React.createElement('div', {
        className: classNames(allClasses)
      });
    }
  }]);

  return HSpacer;
}(Component);

export default withStyles(styles)(HSpacer);